import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  "NAME": (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};



const duck = createDuck("ADD_PUBLICACION", newActions, newReducers);

const addPublicacionThunk = (data) => {
  const url = `${baseUrl}/startPublicacion`;
  return createThunk(axios, "post", duck.actions, url, data);
};



const duckMarcas = createDuck("GET_MARCAS", newActions, newReducers);

const getMarcasThunk = () => {
  const url = `${baseUrl}/getMarcas`;
  return createThunk(axios, "get", duckMarcas.actions, url, null);
};



const duckSetearImagenPrincipal = createDuck("SETEAR_IMAGEN_PRINCIPAL", newActions, newReducers);

const setearImagenPrincipalThunk = (data) => {
  const url = `${baseUrl}/setearImagenPrincipalEnPublicacion`;
  return createThunk(axios, "post", duckSetearImagenPrincipal.actions, url, data);
};



const duckGetImagenesTemporales = createDuck("GET_IMAGENES_TEMPORALES", newActions, newReducers);

const getImagenesTemporalesThunk = (data) => {
  const url = `${baseUrl}/getImagenes/${data.publicacionID}/pendientes`;
  return createThunk(axios, "get", duckGetImagenesTemporales.actions, url, null);
};



const duckGetImagenes = createDuck("GET_IMAGENES", newActions, newReducers);

const getImagenesThunk = (data) => {
  const url = `${baseUrl}/getImagenes/${data.publicacionID}/editadas`;
  return createThunk(axios, "get", duckGetImagenes.actions, url, null);
};



const duckEliminarImagen = createDuck("ELIMINAR_IMAGEN", newActions, newReducers);

const eliminarImagenThunk = (data) => {
  const url = `${baseUrl}/eliminarImagenEnPublicacion`;
  return createThunk(axios, "post", duckEliminarImagen.actions, url, data);
};


const duckSubModelos = createDuck("GET_SUB_MODELOS", newActions, newReducers);

const getSubModelosThunk = (marca, modelo, origen, page, limit) => {

  const url = `${baseUrl}/${marca}/${modelo}/submodelos/${origen}?page=${page}&limit=${limit}`;
  return createThunk(axios, "get", duckSubModelos.actions, url, null);
};

const duckGetPublicacionIncompleta = createDuck("GET_PUBLICACION_INCOMPLETA", newActions, newReducers);

const getPublicacionIncompletaThunk = (id) => {
  const url = `${baseUrl}/getPublicacionIncompletaById/${id}`;
  return createThunk(axios, "get", duckGetPublicacionIncompleta.actions, url, null);
};

const duckUpdateProductOption = createDuck("UPDATE_PRODUCT_OPTION", newActions, newReducers);

const updateProductOptionThunk = (publicacion) => {
  const url = `${baseUrl}/updateProductOption`;
  return createThunk(axios, "patch", duckUpdateProductOption.actions, url, {publicacion});
};

const duckUpdateProductDetails = createDuck("UPDATE_PRODUCT_DETAILS", newActions, newReducers);

const updateProductDetailsThunk = (publicacion) => {
  const url = `${baseUrl}/updateProductDetails`;
  return createThunk(axios, "patch", duckUpdateProductDetails.actions, url, {publicacion});
};

const duckPublicacionesPorValidar = createDuck("GET_PUBLICACIONES_POR_VALIDAR", newActions, newReducers);

const getPublicacionesPorValidarThunk = (publicacion) => {
  const url = `${baseUrl}/publicacionesPorValidar`;
  return createThunk(axios, "get", duckPublicacionesPorValidar.actions, url, {publicacion});
};

const duckPublicacionesByUser = createDuck("GET_PUBLICACIONES_BY_USER", newActions, newReducers);

const getPublicacionesByUserThunk = (token, activePage, limit) => {

  const url = `${baseUrl}/publicacionesByUser/${token}?page=${activePage}&limit=${limit}`;
  return createThunk(axios, "get", duckPublicacionesByUser.actions, url, {});
};

const duckSubmodeloById = createDuck("GET_SUBMODELO_BY_ID", newActions, newReducers);

const getSubmodeloByIdThunk = (id) => {
  const url = `${baseUrl}/submodelo/${id}`;
  return createThunk(axios, "get", duckSubmodeloById.actions, url, {});
};

const duckPublicacionesByOrg = createDuck("GET_PUBLICACIONES_BY_ORG", newActions, newReducers);


const getPublicacionesByOrgThunk = (token, searchId, activePage, limit) => {

  const url = `${baseUrl}/getPublicacionesByOrganizacion/${token}?page=${activePage}&limit=${limit}&id=${searchId}`;
  return createThunk(axios, "get", duckPublicacionesByOrg.actions, url, {});
};

export default {
  duck,
  addPublicacionThunk,
  duckMarcas,
  getMarcasThunk,
  duckSetearImagenPrincipal,
  setearImagenPrincipalThunk,  
  duckGetImagenesTemporales,
  getImagenesTemporalesThunk,
  duckGetImagenes,
  getImagenesThunk,
  duckEliminarImagen,
  eliminarImagenThunk,
  getSubModelosThunk,
  duckSubModelos,
  getPublicacionIncompletaThunk,
  duckGetPublicacionIncompleta,
  getPublicacionIncompletaThunk,
  duckUpdateProductOption,
  updateProductOptionThunk,
  duckUpdateProductDetails,
  updateProductDetailsThunk,
  duckPublicacionesPorValidar,
  getPublicacionesPorValidarThunk,
  getPublicacionesByUserThunk,
  duckPublicacionesByUser,
  duckSubmodeloById,
  getSubmodeloByIdThunk,
  duckPublicacionesByOrg,
  getPublicacionesByOrgThunk,
};
